
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[airport]/class/[class]",
      function () {
        return require("private-next-pages/[airport]/class/[class]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[airport]/class/[class]"])
      });
    }
  